import { useAccountBuyerGetAnimals } from '@application/api';
import type { AnimalTypeEnum } from '@gql/graphql';
import type { SelectOption } from '@presentation/components';
import { useMemo } from 'react';

export const useGetAnimals = (animalType?: AnimalTypeEnum) => {
  const getAnimals = useAccountBuyerGetAnimals({
    archived: false,
    animalType,
  });

  const animalOptions = useMemo((): SelectOption<number>[] => {
    return (getAnimals.animals ?? []).map((animal) => ({
      value: animal.id,
      label: animal.name,
    }));
  }, [getAnimals.animals]);

  return {
    ...getAnimals,
    animalOptions,
  };
};
